import React, { useEffect, useRef, useCallback  } from "react";

// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { typeAdded, typeGetById } from "../../../Redux/typeReduce";
import { useTranslation } from 'react-multi-lang'
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { verification } from "../../../Redux/usersReduce";

function AjouterType({client}) {
  const t = useTranslation();  
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }
  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  const [nom, setNom] = React.useState("");
  const [nomEn, setNomEn] = React.useState("");
  const [order, setOrder] = React.useState("");
  const [id, setId] = React.useState(0);
  const saveCalled = useRef(false);
  function submitForm(event) {
    if (nom !== "" && nomEn !== "") {
      if (saveCalled.current) return;
      saveCalled.current = true;
      dispatch(typeAdded({ nom, nomEn, id }));
      if (isNaN(location.id) === true) {
        notify(1, t("add_txt"));
        setTimeout(async () => {
          listeType();
        }, 800);
      } else {
        notify(1, t("update_txt"));
        setTimeout(async () => {
          listeType();
        }, 800);
      }
    } else {
      notify(2, t("Type.type_obligatoire"));
    }
  }

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);
  
  useEffect(() => {
    verifToken()
    async function getType() {
      if (isNaN(location.id) === false) {
        var type = await dispatch(typeGetById(location.id));
        var entities = type.payload;
        setNom(entities.nom);
        setNomEn(entities.nom_en);
        setId(location.id);
      }
    }
    getType();
  }, [location.id, dispatch]);

  function listeType() {
    navigate.push(client+"/typeList");
  }
  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={listeType}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t("list")}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  <Card.Header>
                    <Card.Title as="h4">
                      {typeof location.id == "undefined"
                        ?
                        t("type.add")
                        : t("type.update")}
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>   {t("name")} * </label>
                          <Form.Control
                            defaultValue={nom}
                            placeholder="Nom"
                            type="text"
                            onChange={(value) => {
                              setNom(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>

                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>   {t("name")} En* </label>
                          <Form.Control
                            defaultValue={nomEn}
                            placeholder="Nom En"
                            type="text"
                            onChange={(value) => {
                              setNomEn(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Button
                      className="btn-fill pull-right"
                      type="button"
                      variant="info"
                      onClick={submitForm}
                    >
                      {t("save")}
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

export default AjouterType;
